import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { IoMdClose } from "react-icons/io";
import { showIconByServiceId } from "../../../helper/showIconByServiceId";
import jsPDF from "jspdf";
import "jspdf-autotable";
import StatusChanger from "../edit/status-chenger";
import {FaEye, FaPencilAlt} from "react-icons/fa";
import {Link} from "react-router-dom";

const DataTable = ({ data, setData, rowsPerPage, currentPage }) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");

  // Handle sorting logic
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = [...data].sort((a, b) => {
    if (!orderBy) return 0;
    if (a[orderBy] === null || b[orderBy] === null) return 0; // Null-safe comparison
    if (a[orderBy] < b[orderBy]) return order === "asc" ? -1 : 1;
    if (a[orderBy] > b[orderBy]) return order === "asc" ? 1 : -1;
    return 0;
  });

  // Export PDF
  const exportPDF = () => {
    const doc = new jsPDF();
    doc.text("services Table", 14, 10);
    doc.autoTable({
      startY: 20,
      head: [
        [
          "ID",
          "Service",
          "Service Type",
          "User Name",
          "Price",
          "Panel URL",
          "Payment Method",
          "Created At",
          "Status Payment",
          "Status",
        ],
      ],
      body: sortedData.map((item) => [
        item.request_id,
        item.our_service || "N/A",
        item.our_service_type || "N/A",
        item.user_name || "N/A",
        item.price || "N/A",
        item.panel_url || "N/A",
        item.payment_method || "N/A",
        item.created_at || "N/A",
        item.status_payment || "N/A",
        item.status || "N/A",
      ]),
    });
    doc.save("ServicesTable.pdf");
  };

  return (
    <>
      {/*<button*/}
      {/*  onClick={exportPDF}*/}
      {/*  className="bg-primary text-white p-2 rounded mb-3"*/}
      {/*>*/}
      {/*  Export to PDF*/}
      {/*</button>*/}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow className="bg-primary">
              {[
                { label: "ID", key: "request_id" },
                { label: "Icon", key: null },
                { label: "Service", key: "our_service" },
                { label: "Service Type", key: "our_service_type" },
                { label: "User Name", key: "user_name" },
                { label: "Price", key: "price" },
                { label: "Panel URL", key: null },
                { label: "Payment Method", key: "payment_method" },
                { label: "Created At", key: "created_at" },
                { label: "Status Payment", key: "status_payment" },
                { label: "Status", key: "status" },
                { label: "Action", key: "action" },
              ].map((column) => (
                <TableCell
                  align="center"
                  className="!text-darkTextColor whitespace-nowrap"
                  key={column.label}
                  onClick={
                    column.key ? () => handleSort(column.key) : undefined
                  }
                  style={{ cursor: column.key ? "pointer" : "default" }}
                >
                  {column.label}
                  {column.key &&
                    (orderBy === column.key ? (
                      order === "asc" ? (
                        <span> ▲</span>
                      ) : (
                        <span> ▼</span>
                      )
                    ) : (
                      ""
                    ))}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData.map((item) => (
              <TableRow
                key={item.request_id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{item?.request_id}</TableCell>
                <TableCell align="center">
                  <img
                    src={showIconByServiceId(item?.our_service_id)}
                    alt="icon"
                    style={{
                      maxHeight: "37px",
                      maxWidth: "40px",
                      objectFit: "contain",
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  {item?.our_service || <IoMdClose style={{ color: "red" }} />}
                </TableCell>
                <TableCell align="center">
                  {item?.our_service_type || (
                    <IoMdClose style={{ color: "red" }} />
                  )}
                </TableCell>
                <TableCell align="center">{item?.user_name}</TableCell>
                <TableCell align="center">{item?.price}</TableCell>
                <TableCell align="center">
                  <a
                    className="inline-block w-full max-w-48 truncate"
                    href={item?.panel_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item?.panel_url}
                  </a>
                </TableCell>
                <TableCell align="center">{item?.payment_method}</TableCell>
                <TableCell align="center">{item?.created_at}</TableCell>
                <TableCell align="center">
                  <span
                    className={`badge w-24 text-darkTextColor ${
                      item?.status_payment === "paid"
                        ? "bg-[#28a745]"
                        : item?.status_payment === "pending"
                        ? "bg-[#f7cb73]"
                        : "bg-[#ff6877]"
                    }`}
                  >
                    {item?.status_payment}
                  </span>
                </TableCell>
                <TableCell align="center">
                  <StatusChanger
                    data={item}
                    setData={setData}
                    rowsPerPage={rowsPerPage}
                    currentPage={currentPage}
                  />
                </TableCell>
                <TableCell align="center">
                  <Link to={`/Orders/${item?.uuid}`} color="inherit" underline="none">
                    <FaEye className="text-[#6c757d]" />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default DataTable;
